import { render, staticRenderFns } from "./AgreeToReceiveMail.vue?vue&type=template&id=65105fc0&scoped=true&"
import script from "./AgreeToReceiveMail.vue?vue&type=script&lang=js&"
export * from "./AgreeToReceiveMail.vue?vue&type=script&lang=js&"
import style0 from "./AgreeToReceiveMail.vue?vue&type=style&index=0&id=65105fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65105fc0",
  null
  
)

export default component.exports